import React from 'react'
import { useSingleResource } from '../../../api/singleQueries'
import { GroupType, ProductType } from './types'
import { Box } from '@mui/material'
import { AddProductsToGroup } from './AddProductsToGroup'
import { Table } from 'shared/ui/Table/Table'
import { removeProductFromGroup } from './utility'
import { ConfirmWithDialogButton } from 'shared/ui'
import { useSortableProductColumns } from '../resourceList/utility'

export function Group() {
  const { item, reFetch } = useSingleResource<GroupType>()
  if (!item) return null
  return (
    <Box>
      <Box>{`Group: ${item.id} - ${item.name}`}</Box>
      <Box padding="15px">
        <Box>Select Products To Add To Group</Box>
        <AddProductsToGroup group={item} onAdded={reFetch} />
      </Box>
      <Box padding="15px">
        <ProductsTable group={item} onRemoved={reFetch} />
      </Box>
    </Box>
  )
}

function ProductsTable({
  group,
  onRemoved,
}: {
  group: GroupType
  onRemoved: () => void
}) {
  const { products, name } = group

  const { sorted, columns } = useSortableProductColumns(products)
  const withRemove = [
    ...columns,
    {
      title: 'Remove',
      width: 50,
      rowContent({ id, title }: ProductType) {
        const onClick = async () => {
          await removeProductFromGroup(group, id)
          onRemoved()
        }
        return (
          <Box>
            <ConfirmWithDialogButton
              onClick={onClick}
              dialogTitle={'Remove From Group'}
              dialogContent={
                <Box>
                  Remove <strong>{title}</strong> from group{' '}
                  <strong>{name}</strong>?
                </Box>
              }
            >
              Remove
            </ConfirmWithDialogButton>
          </Box>
        )
      },
    },
  ]
  return <Table columns={withRemove} items={sorted} />
}
